import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { libraryTabEnums, libraryTabTypes, LibraryFilter, LibrarySelectedFilters, GoalsTab, TargetsTab, OptionsTab } from './fragments';
import { TabSwitcher } from 'components';

export const Library = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const checkGoals = info?.tabType ? info?.tabType === libraryTabEnums.GOALS : libraryTabEnums.GOALS;
    const checkTargets = info?.tabType && info?.tabType === libraryTabEnums.TARGETS;
    const checkOptions = info?.tabType && info?.tabType === libraryTabEnums.OPTIONS;

    return (
        <div>
            <div className="space-between-flex-start" style={{ gap: 50, marginBottom: 12 }}>
                <TabSwitcher list={libraryTabTypes} defaultType={libraryTabEnums.GOALS} />
                <LibraryFilter />
            </div>

            <LibrarySelectedFilters />

            <div>
                {checkGoals && <GoalsTab />}

                {checkTargets && <TargetsTab />}

                {checkOptions && <OptionsTab />}
            </div>
        </div>
    );
};
